<div
  class="input-base phone-input-container"
  [class]="{
    'input-large': inputSize() === InputSize.large,
    'input-small': inputSize() === InputSize.small,
    'input-error': error(),
    disabled: disabled(),
  }">
  <div
    class="country-code-label"
    [floatUi]="countryPicker"
    [showTrigger]="NgxFloatUiTriggers.click"
    [placement]="NgxFloatUiPlacements.BOTTOMSTART"
    [positionFixed]="true"
    [preventOverflow]="true"
    [hideOnScroll]="true"
    [class]="{ disabled: disabled() }"
    [disabled]="disabled()">
    <span>{{ selectedCountryCode() }}</span>
    <mat-icon class="button-icon" [svgIcon]="'chevron-down'"></mat-icon>
  </div>
  <div class="phone-code-label" [class]="{ disabled: disabled() }">
    {{ selectedCountryPhoneCode() }}
  </div>
  <input
    class="phone-input"
    [class.disabled]="disabled()"
    type="tel"
    [maskito]="PhoneNumberUtils.maskitoOptions10Digit"
    [attr.id]="controlId()"
    [value]="value()"
    [disabled]="disabled()"
    [placeholder]="placeholder()"
    (input)="handleInput($event)" />
</div>

<float-ui-content #countryPicker>
  <div class="country-picker">
    @for (country of countries(); track $index) {
      <span class="country-picker-item" (click)="countryClicked(country); countryPicker.hide()">
        {{ country.countryCode }}
      </span>
    }
  </div>
</float-ui-content>
